import { participantsFilterWorkerFactory as getFilterInstance } from 'common-data-handling';
import { useEffect, useMemo, useState } from 'react';
import appPath from '../../../misc/appPath';
import { hasParticipantFilterActive } from '../../filters/participantsFilters';
import { useEventConnections } from '../connections/useEventConnections';
import { useActiveParticipantsFilter } from './useActiveParticipantsFilter';
import { useEventParticipants } from './useEventParticipants';
import { useParticipantsCategories } from './useParticipantsCategories';

// resolved lazily because setupHistory() runs after this module is evaluated
const workerURL = () => appPath('js/filter-participants.webworker.js?v=' + __VERSION__);

/**
 * Returns the participants filtered
 * @param  {Number} eventId     Event identification
 * @return {array}              [filteredParticipants, filterParams, filtering];
 */
export function useFilteredParticipants(eventId, filterParams, options = {}) {
    const { filter: additionalFilter, connections: listConnections = true, meetings: listMeetings = true, qa: listQA = true } = options,
        participants = useEventParticipants(eventId, {
            connections: listConnections,
            meetings: listMeetings,
            qa: listQA,
        }),
        categories = useParticipantsCategories(eventId),
        connections = useEventConnections(eventId),
        activeFilter = useActiveParticipantsFilter(eventId),
        [output, setOutput] = useState([[], filterParams || activeFilter, true]);

    if (!filterParams) filterParams = activeFilter;

    useEffect(() => {
        let waitingResponse = true;
        // console.log('FILTERING PARTICIPANTS', filterParams, hasParticipantFilterActive(filterParams));
        if (hasParticipantFilterActive(filterParams)) {
            setOutput((output) => [output[0], output[1], true]);

            getFilterInstance(workerURL())({ participants, filterParams, categories, connections }).then(({ filteredParticipants }) => {
                // console.log('DEBUG', 'filter action complete', filterParams, filteredParticipants);
                if (waitingResponse) {
                    setOutput([filteredParticipants, filterParams]);
                }
            });
        } else {
            setOutput([participants]);
        }
        return () => (waitingResponse = false);
    }, [participants, JSON.stringify(filterParams), categories, connections]);

    return useMemo(() => {
        let result = output[0];

        if (additionalFilter) result = result.filter(additionalFilter);

        return [result, output[1], output[2]];
    }, [additionalFilter, output]);
}
